import { post } from "../Config";

export function PostSurveySubmit({ data }) {
  return post({ url: `/api/pii/v1/surveyed/submit`,data });
}
